import $ from 'jquery'

export default {
    outSideClicks(el, toggle) {
        if ($(el).length) {
            $('body').on('click', function (e) {
                if (e.originalEvent !== undefined) {
                    // console.log($(e.target).parents())
                    if (!$(e.target).parents(el).length) {
                        $(el).removeClass('is-active');
                    }
                }
            })
        }
    },
    getCurrentTailwindScreen() {
        const $twScreen = $('.tw-screen');
        if($twScreen.length === 0) return null;

        this.setCurrentTailwindScreen();

        return $twScreen.data('screen')
    },
    setCurrentTailwindScreen() {
        const $twScreen = $('.tw-screen');
        if($twScreen.length === 0) return null;
        // let cssContentProp = $twScreen.css('content')
        let prop = $twScreen.css('background-image')

        // console.log(prop)
        // alert(cssContentProp)
        // $twScreen.html(prop.substring(prop.indexOf("screen/") + 7, prop.length - 2))
        const match = prop.match("_(.*)_")
        // console.dir(match)
        $twScreen.data('screen', match ? match[1] : 'base')
    },
    scrollToElement($scrollEl, speed = 800, adjust = 0) {
        // let appBarHeight = $('.app-bar').outerHeight()
        //
        // $('html, body').animate({
        //     scrollTop: $scrollEl.offset().top - appBarHeight
        // }, speed)

        this.scrollToPosition($scrollEl.offset().top + adjust, speed)
    },
    scrollToPosition(scrollTop, speed = 800, includeAppBar = true) {
        let appBarHeight = includeAppBar ? $('.app-menu-bar').outerHeight() : 0

        // console.log(scrollTop - appBarHeight)
        $('html, body').animate({
            scrollTop: scrollTop - appBarHeight
        }, speed)
    },
    removeFormErrors($form) {
        $form.children().find(`.form-input--error`).removeClass('form-input--error')
        $form.children().find(`.form-input--error`).removeAttr('data-error')
    },
    showFormFieldError($formField, error) {
        // let $formField = $form.children().find(`[name="${fieldName}"]`).closest('.form-input');
        let $formCheckboxParent = $formField.closest('.form-checkboxes');
        let $formRadioParent = $formField.closest('.form-radios');
        let $formInputParent = $formField.closest('.form-input');

        let $formParent = $formCheckboxParent;
        $formParent = $formRadioParent.length ? $formRadioParent : $formParent;
        $formParent = $formInputParent.length ? $formInputParent : $formParent;
        // if (fieldName === 'main') {
        //   $formInputParent = $username.closest('.form-input');
        // }

        console.log($formParent)
        if ($formParent.length) {
            $formParent.addClass('form-input--error');
            $formParent.attr('data-error', error);
        }
    },
    getUrlParameter(sParam, search) {
        search = search ? search : window.location.search
        var sPageURL = search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    },
    toggleModal (modalId) {
        // const body = document.querySelector('body')
        // const modal = document.querySelector('.modal')
        let $modal = $(`[data-modal=${modalId}]`)
        $modal = $modal.length ? $modal : $('.modal')
        // $modal.removeClass('hidden')
        // $modal.toggleClass('hidden opacity-0')

        // convert tailwind classes to inline styles AND remove the classes
        $modal.hasClass('opacity-0') ? $modal.css({ 'opacity': '0'}) : '';
        // $modal.hasClass('h-0') ? $modal.css({ 'height': '0'}) : '';
        $modal.removeClass('h-0 opacity-0')

        if ($modal.css('opacity') === '0') {
            $modal.css({
                'opacity': '1',
                // 'height': '100%'
            });
        } else {
            $modal.css({
                'opacity': '0',
                // 'height': '0'
            });
        }

        // setTimeout(function () {
        //     $modal.toggleClass('opacity-0')
        // }, 10)
        // setTimeout(function () {
        //     if($modal.hasClass('opacity-0')) {
        //         $modal.addClass('hidden')
        //     }
        // }, 200)
        $modal.toggleClass('pointer-events-none')
        $('body').toggleClass('modal-active')
    },
    formGoToStep(step) {
        $('.form-steps').data('current-step', step);
        $('.form-step').removeClass('form-step--active');
        $('.form-step[data-id="' + step + '"]').addClass('form-step--active');

        $('[data-step]').addClass('hide')
        $('[data-step="' + step + '"]').removeClass('hide')

        $('.form-control--back').addClass('opacity-0')
        if (step > 1) {
            $('.form-control--back').removeClass('opacity-0')
        }
        // console.log(step, loggedInUser)

        this.formAfterStep();
    },
    formAfterStep() {
        // const $ele = $('.form-container');
        const $ele = $('.form-steps').parent();
        $('html, body').animate({
            scrollTop: $ele[0].getBoundingClientRect().top + $(window).scrollTop() - $('.app-bar').outerHeight()
        }, 500)
    },
    formShowSuccessStep() {
        $('.form-controls-wrapper').addClass('hide');
        $('.form-steps').addClass('hide');

        $('[data-step]').addClass('hide')
        $('[data-step="success"]').removeClass('hide')

        this.formAfterStep();
    }
}
